import { toRefs, inject, computed } from 'vue';
import { convertToUnit } from '../../utils/component-lib.esm6.js';

//
var script = {
  props: {
    color: {
      type: String,
      required: true
    },
    component: {
      type: String,
      default: 'div'
    },
    selectable: Boolean,
    selected: Boolean,
    size: {
      type: [Number, String],
      default: '3rem'
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      color,
      component,
      selectable,
      selected,
      size
    } = toRefs(props);
    const {
      selectedColor,
      size: pickerSize,
      onSelect,
      isInGroup
    } = inject('pickerOptions', {
      isInGroup: false
    });
    const isSelected = computed(() => {
      if (selected.value) return true;
      if (!isInGroup) return false;
      return selectedColor.value === color.value;
    });
    const tag = computed(() => {
      if (selectable.value) return 'button';
      return component.value;
    });
    const attributes = computed(() => {
      const attrs = {
        'aria-label': `Color ${color.value}`,
        title: `Color ${color.value}`
      };
      if (selectable.value) {
        attrs.type = 'button';
      }
      return attrs;
    });
    const styles = computed(() => {
      const sizeWithUnit = convertToUnit(isInGroup ? pickerSize.value : size.value);
      return {
        '--c-color': color.value,
        '--c-size': sizeWithUnit
      };
    });
    const classes = computed(() => {
      return {
        'v-color--selectable': selectable.value,
        'v-color--selected': isSelected.value
      };
    });
    function handleClick() {
      if (isInGroup) onSelect(color.value);
      emit('click', color.value);
    }
    return {
      tag,
      attributes,
      styles,
      classes,
      handleClick,
      isSelected
    };
  }
};
export { script as default };